import { Loading } from "@components/TransitionRoot";
import React, { useEffect, useState } from "react";
import { useI18n } from "../../I18nextProvider";

interface LazyLoadProps {
  load: any;
  children?: any;
  loading?: any;
  [x: string | number | symbol]: unknown;
}

const LazyLoad = ({ load, loading, children, ...rest }: LazyLoadProps) => {
  const [module, setModule] = useState(null);
  const LoadComponent = loading || Loading;
  const Component = module?.default;

  const i18n = useI18n();

  useEffect(() => {
    load().then(
      (cp) => {
        setModule(cp);
      },
      (err) => {
        console.error(err);
      }
    );
  }, [load]);

  return Component ? (
    <Component {...rest}>
      {children}
      <span className="msgLoad360">{i18n.t("global.loadDrag360")}</span>
    </Component>
  ) : (
    <LoadComponent />
  );
};

export default LazyLoad;
